var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52615",
    "data-name": "Group 52615",
    transform: "translate(-446 -910)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18647",
    "data-name": "Rectangle 18647",
    transform: "translate(446 910)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Search",
    "data-name": "Iconly/Bold/Search",
    transform: "translate(466 930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Search-2",
    "data-name": "Search",
    d: "M39.916,44.119l-4.771-5.468a2.437,2.437,0,0,1,0-3.428,2.218,2.218,0,0,1,3.135,0l5.747,4.639h.1a3.034,3.034,0,0,1,0,4.257,2.958,2.958,0,0,1-4.212,0ZM0,19.507A19.4,19.4,0,0,1,19.3,0,19.193,19.193,0,0,1,32.946,5.715,19.611,19.611,0,0,1,38.6,19.507,19.4,19.4,0,0,1,19.3,39.016,19.4,19.4,0,0,1,0,19.507Z",
    transform: "translate(0 0)",
    fill: "#93a750"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBar);
export default __webpack_public_path__ + "static/media/SearchBar.fb4ce8b1c793968f10eda09fbc9ce126.svg";
export { ForwardRef as ReactComponent };